import type { UserProfileDetail } from '../types/userDetail.types';
import { AuthMask } from '@/core/permissions/AuthMask';

export function WorkStatusCard({ user }: { user: UserProfileDetail }) {
 return (
 <div className="bg-white rounded-md p-6 border border-slate-100">
 <div className="flex items-center justify-between mb-6">
 <h3 className="sm:text-sm text-xs text-slate-800">Trạng thái công việc</h3>
 <span className="px-2 py-0.5 rounded-md bg-emerald-50 text-emerald-600 sm:text-sm text-xs tracking-wider border border-emerald-100">
 Đang làm việc
 </span>
 </div>

 <div className="space-y-4">
 <SideItem label="Ngày vào công ty" value={user.join_date} />
 <SideItem label="Thâm niên" value={user.seniority} />
 <SideItem label="Loại nhân sự" value={user.employment_type === 'full_time' ? 'Nhân sự chính thức' : user.employment_type} />
 <SideItem label="Nguồn tuyển dụng" value={user.recruitment_source} />
 </div>
 </div>
 );
}

export function SideItem({ label, value, isMasked }: { label: string; value?: string; isMasked?: boolean }) {
 return (
 <div className="flex items-center justify-between gap-4">
 <span className="sm:text-sm text-xs text-slate-400 whitespace-nowrap">{label}</span>
 {isMasked ? (
 <AuthMask>
 <span className="sm:text-sm text-xs text-slate-700 text-right">{value ||"-"}</span>
 </AuthMask>
 ) : (
 <span className="sm:text-sm text-xs text-slate-700 text-right">{value ||"-"}</span>
 )}
 </div>
 );
}
